import React from 'react'

const Profile = () => {
  return (
    <div className='d-flex justify-content-center align-items-center'>
    <h1>Profile</h1>

</div>

  )
}

export default Profile